export default {
  namespaced: true,
  state: {
    boardNoticeMovePopIsDone: false
  },
  mutations: {
    SET_MOVEPOPISDONE(state: State, isDone: boolean): void {
      state.boardNoticeMovePopIsDone = isDone;
    }
  },
  actions: {
  },
  getters: {
    boardNoticeMovePopIsDone(state: State): boolean {
      return state.boardNoticeMovePopIsDone;
    }
  }
};

interface State {
  boardNoticeMovePopIsDone: boolean;
}